import { Node, mergeAttributes } from '@tiptap/core';

const ParagraphBlock = Node.create({
  name: "paragraphBlock",
  content: "paragraph block*",
  group: "block",
  priority: 999,
  parseHTML() {
    return [
      {
        tag: 'div[data-block="true"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ["data-block"]: "true"
      }),
      0
    ];
  }
});

export { ParagraphBlock };
//# sourceMappingURL=ParagraphBlock.js.map
